import { Component, inject, OnInit } from '@angular/core';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { TranslatePipe } from '@ngx-translate/core';
import { ReserveLoadingService } from '../../shared/services/reserve-loading.service';
import { UserPlanRequest } from '../../shared/interfaces/reserve-health.model';
import { Router } from '@angular/router';
import { ID_LOGIN_TYPE } from '../../shared/constants/common.constants';
import {
  BusinessPlanRequest,
  PackageDetail,
} from '../../shared/interfaces/reserve-loading.model';
import { API_PARAMS } from '../../shared/constants/api.constants';
import { NgOptimizedImage } from '@angular/common';
import { IdLoginRequest } from '../../shared/interfaces/id-login.model';
import { MemberInfoResponse, ModifyInfoService } from '../../shared/services/modify-info.service';

/**
 * 方案預算loading頁面
 */
@Component({
  selector: 'app-reserve-loading',
  standalone: true,
  imports: [TranslatePipe, NgOptimizedImage],
  templateUrl: './reserve-loading.component.html',
  styleUrl: './reserve-loading.component.scss',
})
export class ReserveLoadingComponent implements OnInit {
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  reserveLoadingService: ReserveLoadingService = inject(ReserveLoadingService);
  modifyInfoService: ModifyInfoService = inject(ModifyInfoService);
  router: Router = inject(Router);

  ngOnInit(): void {
    // 將當前預約步驟設置為2.5(步驟條不顯示)
    setTimeout(() => {
      this.sharedStorageService.set('reserveStep', 2.5);
    });
    
    // 解決髒資料問題，若是已登入狀態
    if (this.sharedStorageService.get('loginStatus') === 'memberLogin') {
      this.modifyInfoService.getMemberInfo().subscribe({
        next: (res: MemberInfoResponse) => {

          // 髒資料由 interceptor 處理
          if (res.statusCode === 'S0000') {
            console.log('token有效，資料保留');
          }
        }
      });
    }

    const userPlanRequest: UserPlanRequest | null =
      this.sharedStorageService.get('userPlanRequest') ?? null;
    const businessPlanRequest: BusinessPlanRequest | null =
      this.sharedStorageService.get('businessPlanRequest') ?? null;
      if (
        this.sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.PERSONAL &&
        userPlanRequest
      ) {
        // 個人預約
        this.reserveLoadingService
          .getUserPlanResult(userPlanRequest)
          .subscribe(res => {
            if (res.statusCode === 'S0000' && res.data) {
              // 處理折扣率四捨五入到小數點後五位，如果 discountRate 不存在則設為預設值
              const processedData = {
                ...res.data,
                allCheckup: res.data.allCheckup ? {
                  ...res.data.allCheckup,
                  discountRate: res.data.allCheckup.discountRate
                    ? Number(res.data.allCheckup.discountRate).toFixed(5)
                    : '1.00000'
                } : {
                  discountRate: '1.00000',
                  price: '0',
                  abnormalCnt: '0',
                  potentialCnt: '0',
                  packageList: []
                },
                aiExclusive: res.data.aiExclusive ? {
                  ...res.data.aiExclusive,
                  discountRate: res.data.aiExclusive.discountRate
                    ? Number(res.data.aiExclusive.discountRate).toFixed(5)
                    : '1.00000'
                } : {
                  discountRate: '1.00000',
                  price: '0',
                  abnormalCnt: '0',
                  potentialCnt: '0',
                  packageList: []
                },
                basicCheckup: res.data.basicCheckup ? {
                  ...res.data.basicCheckup,
                  discountRate: res.data.basicCheckup.discountRate
                    ? Number(res.data.basicCheckup.discountRate).toFixed(5)
                    : '1.00000'
                } : {
                  discountRate: '1.00000',
                  price: '0',
                  abnormalCnt: '0',
                  potentialCnt: '0',
                  packageList: []
                }
              };

              this.sharedStorageService.set('userPlanResponse', processedData);

              if (this.sharedStorageService.get('healthPlan') === 'special') {
                // 模擬等待請求，特殊活動頁面
                setTimeout(() => {
                  this.router.navigate(['/healthcheck/healthplan/reserve/personalplan']).then();
                }, 3000);
              } else {
                // 模擬等待請求，一般預約頁面
                setTimeout(() => {
                  this.router.navigate(['/healthcheck/reserve/personalplan']).then();
                }, 3000);
              }
            }
          });
      } else if (
        this.sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.ENTERPRISE &&
        businessPlanRequest
      ) {
        // 企業預約
        const businessLoginInfo =
          this.sharedStorageService.get('businessPlanRequest');
        const idLoginRequest = this.sharedStorageService.get('idLoginRequest');
        const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
        console.log('idLoginRequest', idLoginRequest);
        const businessPlanRequest: BusinessPlanRequest = {
          orgNo: businessLoginInfo?.orgNo ?? '',
          employeeId: businessLoginInfo?.employeeId || idLoginRequest?.idNo || createMemberRequest?.idNo || '',
          companyNo: businessLoginInfo?.companyNo ?? '',
          gender: businessLoginInfo?.gender ?? '',
        };
        console.log('businessPlanRequest', businessPlanRequest);
        this.reserveLoadingService
          .getBusinessPlanResult(businessPlanRequest)
          .subscribe(res => {
            if (res.data && res.data.packageList) {
              this.sharedStorageService.set('businessPlanResponse', res.data);

              // 測試用 - 有企業補助金
              // if (res.data?.companyInfo?.sponsorAmt === '0') {
              //   const businessPlanResponse = this.sharedStorageService.get('businessPlanResponse');
              //   if (businessPlanResponse) {
              //     businessPlanResponse.companyInfo.sponsorAmt = '2000';
              //     this.sharedStorageService.set('businessPlanResponse', businessPlanResponse);
              //   }
              // }

              // 模擬等待請求
              setTimeout(() => {
                this.router
                  .navigate(['/healthcheck/reserve/companyplan'])
                  .then();
              }, 3000);
            }
          });
      }
  }
}
